import { mapEnumToOptions } from '@abp/ng.core';

export enum RenewalPeriod {
  Day = 1,
  Month = 2,
  Year = 3,
}

export const renewalPeriodOptions = mapEnumToOptions(RenewalPeriod);
